import { useLayoutContext } from "@circle-react/components/SettingsApp/Layout/LayoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";
import { useIsAppShellAdminAreaEnabled } from "@circle-react/hooks/useIsAppShellAdminAreaEnabled";
import { useLocation } from "@tanstack/react-router";

import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import { AnalyticsLinks } from "./AnalyticsLinks";
import { BrandedAppsDashboardLinks } from "./BrandedAppsDashboardLinks";
import { CommunityBotLinks } from "./CommunityBotLinks";
import { CommunityInboxLinks } from "./CommunityInboxLinks";
import { ContentLinks } from "./ContentLinks";
import { CoursesLinks } from "./CoursesLinks";
import { DevelopersLinks } from "./DevelopersLinks";
import { EmailLinks } from "./EmailLinks";
import { MemberLinks } from "./MemberLinks";
import { NewsletterLinks } from "./NewsletterLinks";
import { PaywallLinks } from "./PaywallLinks";
import { PaywallsAffiliatesLinks } from "./PaywallsAffiliatesLinks";
import { PlansLinks } from "./PlansLinks";
import { SettingsLinks } from "./SettingsLinks";
import { SiteLinks } from "./SiteLinks";
import { WorkflowLinks } from "./WorkflowLinks";

export const NestedNavBar = () => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const pathname = useLocation({ select: location => location.pathname });
  const { config: layoutConfig } = useLayoutContext();
  const isAppShellAdminAreaEnabled = useIsAppShellAdminAreaEnabled();

  const { shouldHideSidebarNestedNavBar } = layoutConfig;

  const isCommunityInboxPage = pathname.includes(
    settingsNavPathV3.community_inbox.index,
  );

  if (shouldHideSidebarNestedNavBar) {
    return null;
  }

  return (
    <div
      className={classNames(
        "h-full",
        !isMemberAreaAppShellEnabled && "bg-primary",
        isAppShellAdminAreaEnabled ? "w-full" : "w-56 lg:w-60",
        isCommunityInboxPage ? "lg:w-[20rem]" : "p-5",
        !isAppShellAdminAreaEnabled &&
          !isCommunityInboxPage &&
          "lg:w-[18.5rem]",
      )}
    >
      <MemberLinks />
      <EmailLinks />
      <NewsletterLinks />
      <SiteLinks />
      <ContentLinks />
      <CoursesLinks />
      <WorkflowLinks />
      <PaywallLinks />
      <SettingsLinks />
      <PlansLinks />
      <AnalyticsLinks />
      <PaywallsAffiliatesLinks />
      <DevelopersLinks />
      <BrandedAppsDashboardLinks />
      {isCommunityInboxPage && <CommunityInboxLinks />}
      <CommunityBotLinks />
    </div>
  );
};
